<template>
  <section class="about-hero" id="identification">
    <div class="about-hero__inner">
      <!-- LEFT -->
      <div class="about-hero__media">
        <img
          class="about-hero__nurse-img"
          src="@/assets/IMG/nurse.png"
          alt="Enfermera"
        />
      </div>

      <!-- RIGHT -->
      <div class="about-hero__copy">
        <h1 class="about-hero__title">
          <span class="about-hero__line about-hero__line--light">SEGURIDAD</span>
          <span class="about-hero__line about-hero__line--light">
            QUE <strong>CRECE</strong>
          </span>
          <span class="about-hero__line about-hero__line--bold">CON ELLOS</span>
        </h1>

        <p class="about-hero__text">
          Somos una empresa enfocada en crear herramientas
          de protección infantil que combinan tecnología,
          prevención y respuesta rápida.<br />
          Desarrollamos soluciones con GPS, NFC y código QR
          para facilitar la localización y el acceso inmediato a
          información médica cuando más se necesita.
        </p>
      </div>

      <!-- Estrellas -->
      <img
        class="about-hero__star about-hero__star--top"
        src="@/assets/IMG/Estrella.png"
        alt="Estrella decorativa"
      />
      <img
        class="about-hero__star about-hero__star--mid"
        src="@/assets/IMG/Estrella.png"
        alt="Estrella decorativa"
      />
      <img
        class="about-hero__star about-hero__star--bottom"
        src="@/assets/IMG/Estrella.png"
        alt="Estrella decorativa"
      />
      <img
        class="about-hero__star about-hero__star--bottom-small"
        src="@/assets/IMG/Estrella.png"
        alt="Estrella decorativa"
      />
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutHero",
};
</script>

<style scoped>
@font-face {
  font-family: "Cocomat Pro";
  src: url("../assets/fonts/CocomatPro-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "Cocomat Pro";
  src: url("../assets/fonts/CocomatPro-Bold.ttf") format("truetype");
  font-weight: 700;
  font-style: normal;
}

/* =========================
   SECCIÓN
========================= */
.about-hero {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  background: #001e46;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
  padding: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* =========================
   CONTENIDO
========================= */
.about-hero__inner {
  width: min(1380px, 100%);
  min-height: 100vh;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.02fr 0.98fr;
  align-items: center;
  gap: clamp(18px, 3vw, 40px);
  padding: 42px clamp(20px, 3.2vw, 48px) 26px;
  position: relative;
  z-index: 2;
}

/* =========================
   IZQUIERDA
========================= */
.about-hero__media {
  position: relative;
  width: 100%;
  min-height: clamp(520px, 52vw, 760px);
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  overflow: visible;
}

.about-hero__nurse-img {
  position: absolute;
  left: -310px;
  top: -70px;
  width: min(860px, 100vw);
  height: auto;
  max-width: none;
  object-fit: contain;
  object-position: left top;
  z-index: 1;
  user-select: none;
  pointer-events: none;
  margin: 0;
  transform: none;
}

/* =========================
   DERECHA
========================= */
.about-hero__copy {
  position: relative;
  text-align: left;
  transform: translateY(-18px);
  z-index: 3;
}

.about-hero__title {
  margin: 0;
  font-family: "Cocomat Pro", Arial, sans-serif;
  color: #ebcfaf;
  line-height: 0.96;
  text-transform: uppercase;
}

.about-hero__line {
  display: block;
  margin: 0;
  padding: 0;
}

.about-hero__line--light {
  font-size: clamp(54px, 6vw, 92px);
  font-weight: 400;
  letter-spacing: 0.01em;
}

.about-hero__line--light strong {
  font-weight: 700;
}

.about-hero__line--bold {
  font-size: clamp(60px, 6.7vw, 104px);
  font-weight: 700;
  letter-spacing: 0.01em;
}

.about-hero__text {
  margin: 24px 0 0;
  max-width: 620px;
  font-family: "Cocomat Pro", Arial, sans-serif;
  color: #f8ead6;
  font-size: clamp(19px, 1.55vw, 30px);
  font-weight: 400;
  line-height: 1.08;
  text-align: left;
}

/* =========================
   ESTRELLAS
========================= */
.about-hero__star {
  position: absolute;
  z-index: 3;
  pointer-events: none;
  user-select: none;
}

.about-hero__star--top {
  top: 54px;
  left: 47%;
  width: 96px;
  transform: rotate(18deg);
}

.about-hero__star--mid {
  right: -60px;
  bottom: 295px; /* sube la estrella */
  width: 76px;
  transform: rotate(-12deg);
}

.about-hero__star--bottom {
  right: -130px;
  bottom: 140px; /* sube la estrella */
  width: 140px;
  transform: rotate(12deg);
}
.about-hero__star--bottom-small {
  right: 0px;
  bottom: 100px; /* sube la estrella */
  width: 64px;
  transform: rotate(-10deg);
}

/* =========================
   LAPTOP / DESKTOP MEDIO
========================= */
@media (max-width: 1280px) {
  .about-hero__inner {
    grid-template-columns: 1fr 1fr;
    gap: 24px;
  }

  .about-hero__nurse-img {
    left: -170px;
    top: -30px;
    width: min(760px, 100vw);
  }

  .about-hero__copy {
    transform: translateY(-6px);
  }

  .about-hero__line--light {
    font-size: clamp(46px, 5.4vw, 78px);
  }

  .about-hero__line--bold {
    font-size: clamp(52px, 5.9vw, 88px);
  }

  .about-hero__text {
    font-size: clamp(17px, 1.4vw, 24px);
    max-width: 560px;
  }
}

/* =========================
   TABLETS / IPADS
   SIEMPRE 2 COLUMNAS
========================= */
@media (min-width: 601px) and (max-width: 1024px) {
  .about-hero {
    min-height: auto;
    padding: 28px 0 24px;
  }

  .about-hero__inner {
    min-height: auto;
    width: min(960px, 94%);
    grid-template-columns: 1fr 1fr;
    gap: 18px;
    padding: 24px 8px 12px;
    align-items: center;
  }

  .about-hero__media {
    min-height: 360px;
    order: 1;
    justify-content: flex-start;
  }

  .about-hero__nurse-img {
    position: absolute;
    left: -120px;
    top: -50px; /* baja solo un poquito */
    width: min(500px, 84vw);
    height: auto;
    transform: none;
    margin: 0;
  }

  .about-hero__copy {
    order: 2;
    transform: translateY(-4px);
    text-align: left;
  }

  .about-hero__line--light {
    font-size: clamp(48px, 7vw, 80px); /* mucho más grande */
    line-height: 0.98;
  }

  .about-hero__line--bold {
    font-size: clamp(56px, 8vw, 100px); /* mucho más grande */
    line-height: 0.96;
  }

  .about-hero__text {
    margin-top: 16px;
    font-size: 0.95rem;
    line-height: 1.18;
    max-width: 100%;
    text-align: left;
  }

  .about-hero__star {
    display: none !important;
  }
}

/* iPad mini / tablets pequeñas */
@media (min-width: 601px) and (max-width: 820px) {
  .about-hero__inner {
    width: min(94%, 760px);
    gap: 12px;
  }

  .about-hero__media {
    min-height: 300px;
  }

  .about-hero__nurse-img {
    left: -90px;
    top: -30px; /* baja solo un poquito */
    width: min(420px, 80vw);
  }

  .about-hero__copy {
    transform: translateY(0);
  }

  .about-hero__line--light {
    font-size: clamp(40px, 7vw, 70px); /* mucho más grande */
  }

  .about-hero__line--bold {
    font-size: clamp(48px, 8vw, 90px); /* mucho más grande */
  }

  .about-hero__text {
    font-size: 0.86rem;
    line-height: 1.18;
  }
}

/* =========================
   CELULARES
   TEXTO ARRIBA / FOTO ABAJO
========================= */
@media (max-width: 600px) {
  .about-hero {
    min-height: auto;
    padding: 20px 0 16px;
  }

  .about-hero__inner {
    width: min(94%, 420px);
    min-height: auto;
    grid-template-columns: 1fr;
    gap: 10px;
    padding: 16px 10px 10px;
  }

  .about-hero__copy {
    order: 1;
    text-align: center;
    transform: translateY(0);
  }

  .about-hero__title {
    text-align: center;
  }

  .about-hero__line--light {
    font-size: clamp(30px, 8vw, 46px);
    line-height: 0.98;
  }

  .about-hero__line--bold {
    font-size: clamp(36px, 9vw, 56px);
    line-height: 0.96;
  }

  .about-hero__text {
    margin: 16px auto 0;
    font-size: 0.92rem;
    line-height: 1.2;
    text-align: center;
    max-width: 100%;
  }

  .about-hero__media {
    order: 2;
    min-height: 260px;
    justify-content: center;
    align-items: flex-end;
  }

  .about-hero__nurse-img {
    position: relative;
    left: -50px; /* más a la izquierda */
    top: auto;
    width: min(430px, 98vw);
    max-width: none;
    margin: 0;
    transform: none;
    display: block;
  }

  .about-hero__star {
    display: none !important;
  }
}

@media (max-width: 480px) {
  .about-hero__inner {
    width: min(94%, 360px);
  }

  .about-hero__media {
    min-height: 220px;
  }

  .about-hero__nurse-img {
    width: min(350px, 96vw);
  }

  .about-hero__line--light {
    font-size: clamp(26px, 8vw, 40px);
  }

  .about-hero__line--bold {
    font-size: clamp(32px, 8.8vw, 48px);
  }

  .about-hero__text {
    font-size: 0.84rem;
  }
}
</style>